export default "__VITE_ASSET__670dbd27__"